module.exports = __webpack_public_path__ + "img/profile_nav_icon.d8e13c87.svg";